// extracted by mini-css-extract-plugin
export default {"root":"DashBoardProject_root__fX2SV","barWrapper":"DashBoardProject_barWrapper__AF9IK","wrapper":"DashBoardProject_wrapper__AiK49","loader":"DashBoardProject_loader__-JSnG"};